import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "process-steps-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.2019 14.2979C1.93285 13.0288 1.9327 10.9714 3.20146 9.70213C4.47066 8.43292 6.52889 8.43248 7.79809 9.70168C9.0673 10.9709 9.0673 13.0287 7.79809 14.2979C6.52889 15.5671 4.47111 15.5671 3.2019 14.2979ZM4.26256 13.2372C3.57915 12.5538 3.57915 11.4458 4.26256 10.7623C4.94598 10.0789 6.05402 10.0789 6.73743 10.7623C7.42085 11.4458 7.42085 12.5538 6.73743 13.2372C6.05402 13.9206 4.94598 13.9206 4.26256 13.2372Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.2019 14.2979C14.9328 13.0288 14.9327 10.9714 16.2015 9.70213C17.4707 8.43292 19.5289 8.43248 20.7981 9.70168C22.0673 10.9709 22.0673 13.0287 20.7981 14.2979C19.5289 15.5671 17.4711 15.5671 16.2019 14.2979ZM17.2626 13.2372C16.5791 12.5538 16.5791 11.4458 17.2626 10.7623C17.946 10.0789 19.054 10.0789 19.7374 10.7623C20.4209 11.4458 20.4209 12.5538 19.7374 13.2372C19.054 13.9206 17.946 13.9206 17.2626 13.2372Z"
    }, null, -1),
    _createElementVNode("path", { d: "M11.5 11.9998C11.5 12.5521 11.0523 12.9998 10.5 12.9998C9.94771 12.9998 9.5 12.5521 9.5 11.9998C9.5 11.4475 9.94771 10.9998 10.5 10.9998C11.0523 10.9998 11.5 11.4475 11.5 11.9998Z" }, null, -1),
    _createElementVNode("path", { d: "M13.5 12.9998C14.0523 12.9998 14.5 12.5521 14.5 11.9998C14.5 11.4475 14.0523 10.9998 13.5 10.9998C12.9477 10.9998 12.5 11.4475 12.5 11.9998C12.5 12.5521 12.9477 12.9998 13.5 12.9998Z" }, null, -1)
  ])))
}
export default { render: render }